module.exports = __webpack_public_path__ + "da43867b8ee3122d4ee78f6739bcf54a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/MCA---Pipilotti-Rist---Pixel-Forest,-2016-RECROP_square.jpg
// module id = 882
// module chunks = 0